import * as TK from 'components/common/TextEditor/components/LinkAttachmentDialog/translations/constants';
import { Translations } from 'translations/types';

export const linkAttachmentDialogEnUsLocale: Translations = {
  [TK.LINK_ATTACHMENT_DIALOG_TITLE]: 'Add Link',
  [TK.LINK_ATTACHMENT_DIALOG_ICON_ALT]: 'Attachment icon',
};
